import { useState, useEffect } from "react";

const STORAGE_KEY = "tbam_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <div style={styles.iconWrap}>
          <span style={styles.cookieIcon}>🍪</span>
        </div>
        <div style={styles.content}>
          <h6 style={styles.heading}>We Value Your Privacy</h6>
          <p style={styles.text}>
            We use cookies and similar technologies to enhance your browsing
            experience, analyse site traffic, and personalise content. By
            clicking <strong>"I Agree"</strong>, you consent to our use of
            cookies and the processing of your personal data as described in
            our{" "}
            <a href="/Privacy-policy" style={styles.link}>
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="/terms-and-conditions" style={styles.link}>
              Terms &amp; Conditions
            </a>
            .
          </p>
        </div>
        <div style={styles.actions}>
          <button onClick={handleAccept} style={styles.agreeBtn}>
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    padding: "0 16px 16px",
    pointerEvents: "none",
  },
  banner: {
    background: "#ffffff",
    borderTop: "3px solid #044188",
    borderRadius: "10px",
    boxShadow: "0 -4px 24px rgba(4, 65, 136, 0.15)",
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
    padding: "20px 24px",
    maxWidth: "860px",
    width: "100%",
    pointerEvents: "all",
  },
  iconWrap: {
    flexShrink: 0,
    paddingTop: "2px",
  },
  cookieIcon: {
    fontSize: "28px",
  },
  content: {
    flex: 1,
  },
  heading: {
    color: "#044188",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    marginBottom: "6px",
  },
  text: {
    color: "#333",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    lineHeight: "1.6",
    margin: 0,
  },
  link: {
    color: "#044188",
    fontWeight: 600,
    textDecoration: "underline",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "8px",
    flexShrink: 0,
  },
  agreeBtn: {
    background: "#044188",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 28px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background 0.2s",
  },
};

export default CookieConsent;
